//Cookie function to check for high contrast
if (Cookies.get('contrast')) {
  $('body').addClass('contrast');
}
$('.contrast-switch').click(function () {
  if (Cookies.get('contrast')) {
    Cookies.remove('contrast', 'active');
  } else {
    Cookies.set('contrast', 'active');
  }
});


//Adds class to body for high contrast css init
$('.contrast-switch').click(function (e) {
  e.preventDefault();
  if ($('body').hasClass('contrast')) {
    $('body').removeClass('contrast');
  } else {
    $('body').addClass('contrast');
  }
});



// WEBPACK FOOTER //
// ./src/js/contrast.js